import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClickMe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.88888 17.5C3.51388 17.5 3.18865 17.3623 2.91319 17.0868C2.63773 16.8114 2.5 16.4861 2.5 16.1111V3.88888C2.5 3.51388 2.63773 3.18865 2.91319 2.91319C3.18865 2.63773 3.51388 2.5 3.88888 2.5H9.70833V3.88888H3.88888V16.1111H16.1111V10.2917H17.5V16.1111C17.5 16.4861 17.3623 16.8114 17.0868 17.0868C16.8114 17.3623 16.4861 17.5 16.1111 17.5H3.88888ZM8 12.9861L7.02777 12L15.1389 3.88888H11.0972V2.5H17.5V8.90279H16.1111V4.87498L8 12.9861Z",
		fill: "#B06803"
	})
});
export default SvgClickMe;
